/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import {
  Card,
  Stack,
  Container,
  Typography,
  Grid,
  CardContent,
  TextField,
} from "@mui/material";
import Color from "../../../theme/color";
import AutoCompleteDropDown from "../../../components/auto-complete-dropdown";
import TexBoxWithLabel from "../../../components/text-field";
import { LoadingButton } from "@mui/lab";
import { PriceTable } from "../../../components/price-table";
import { GET, POST } from "../../../config/https";
import APIS from "../../../config/api";
import { usePersistentState } from "../../../contexts/global-context";
import toast from "react-hot-toast";
import FullScreenLoader from "../../../components/full-screen-loader";
import { Icon } from "@iconify/react";
import { STRING } from "../../../resources/string";
import { IMaskInput } from "react-imask";
import ValidationError from "../../../components/validation-error-label";
import {
  isEmpty,
  isValidEmail,
  isValidPhoneNumber,
} from "../../../utils/validator";
import { marginBottomSize } from "../../../utils/constant";
import { GetLocalStorage } from "../../../utils/local-storage";

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const TextMaskCustom = React.forwardRef<HTMLInputElement, CustomProps>(
  function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="(#00) 000-0000"
        definitions={{
          "#": /[1-9]/,
        }}
        inputRef={ref}
        onAccept={(value: any) =>
          onChange({ target: { name: props.name, value } })
        }
        overwrite
      />
    );
  }
);

interface NewTableData {
  final: Array<{
    eventId: number;
    ticketType: string;
  }>;
  totalTicketPrices: number;
  ticketQuantities: number[];
}
interface TicketData {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: number | null;
}

export default function BookTicket() {
  const [issueTicketData, setIssueTicketData] = useState<TicketData>({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: null,
  });
  const [state]: any = usePersistentState();
  const [selectedEventId, setSelectedEventId] = useState(null);
  const [newTableData, setNewTableData] = useState<NewTableData | null>(null);
  const [loader, setLoader] = useState(false);
  const [eventLists, setCategoryLists] = useState([]);
  const [ticketConfigData, setTicketConfigData] = useState([]);
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  const [isValidation, setIsValidation] = useState(false);
  const [toggleValue, setToggleValue] = useState(false);
  useEffect(() => {
    GetEventDropdown();
  }, []);
  useEffect(() => {
    if (isValidation) {
      validator();
    }
  }, [issueTicketData, newTableData]);

  const getOrganizerId = async () => {
    const userData = await GetLocalStorage("loginData");
    if (userData?.roles?.id === 1) {
      return "";
    }
    if (userData?.roles?.id === 2) {
      return userData?.id;
    }
  };

  const GetEventDropdown = async () => {
    let organizerId = await getOrganizerId();
    await GET(APIS.GET_ALL_EVENTS + "?OrganizerId=" + organizerId)
      .then((res: any) => {
        if (res?.isSuccess) {
          setCategoryLists(res.result);
        } else {
          console.log("error");
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    // setLoader(true);
    if (selectedEventId) {
      const getEvent = async () => {
        setLoader(true);
        try {
          const res: any = await GET(
            APIS.GET_ALL_EVENT_TICKET_CONFIG +
              "?" +
              "eventid=" +
              selectedEventId
          );

          if (res?.isSuccess) {
            setTicketConfigData(res?.result);
          } else {
            setTicketConfigData([]);
            console.log(res?.errors[0]);
          }
        } catch (error) {
          console.error("error", error);
        } finally {
          setLoader(false);
        }
      };
      getEvent();
    }
  }, [selectedEventId, toggleValue]);
  const handleCheckOut = async () => {
    // debugger;
    setIsValidation(true);
    if (!validator()) {
      return;
    }
    if (selectedEventId === null) {
      return;
    }

    let final = newTableData?.final?.filter(function (element: any) {
      return element !== null;
    });
    const orderSummeryDtoData = final?.map((x: any) => {
      return {
        ticketConfigId: x?.id,
        ticketType: x?.ticketType || "",
        qty: x?.qty,
        price: x?.price,
      };
    });

    setLoader(true);

    let param = {
      customerDto: {
        firstName: issueTicketData?.firstName,
        lastName: issueTicketData?.lastName,
        phone: issueTicketData?.phoneNumber,
        email: issueTicketData?.email,
      },
      orderDto: {
        eventId: selectedEventId,
        tax: 0,
        serviceFees: 0,
        subTotal: 0,
        total: state?.data?.totalTicketPrices,
        discount: state?.CheckOutData?.couponDiscountPrice,
        paymentTypeId: STRING.PAYMENT_TYPE_ID.ISSUE_FREE_TICKET,
      },
      couponCode: "",
      ordersItemDto: orderSummeryDtoData,
    };
    await POST(APIS.CHECKOUT, param)
      .then(async (res: any) => {
        if (res?.isSuccess) {
          setIssueTicketData({
            firstName: "",
            lastName: "",
            email: "",
            phoneNumber: null,
          });
          setIsValidation(false);
          setFormErrors({});
          toast.success("Ticket is issued!");
          setToggleValue((prevState) => !prevState);
          await GET(
            `${APIS.SEND_ORDER_CONFORMATION_EMAIL}?OrderId=${res?.result?.orderDetail?.id}`
          )
            .then((res: any) => {
              console.log("successful");
            })
            .catch((error) => {
              console.log("error", error);
            });
        } else {
          toast.error(res?.errors[0]);
          setLoader(false);
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log("error", error);
      })
      .finally(async () => {
        setIsValidation(false);
        setFormErrors({});
        setLoader(false);
      });
  };

  const handleOnChange = (selectedItem: any) => {
    if (selectedItem) {
      setIsValidation(false);
      setFormErrors({});
      setSelectedEventId(selectedItem?.id);
    } else {
    }
  };

  const onChangeFormData = async (key: string, e: any) => {
    let newData = { ...issueTicketData };
    switch (key) {
      case "firstName":
        newData.firstName = e.target?.value;
        break;
      case "lastName":
        newData.lastName = e.target?.value;
        break;
      case "email":
        newData.email = e.target?.value;
        break;
      case "phoneNumber":
        newData.phoneNumber = e.target?.value;
        break;
    }
    setIssueTicketData(newData);
  };

  const handleNewData = (newData: any) => {
    setNewTableData(newData);
  };

  const validator = () => {
    const errors: Record<string, string> = {};
    if (issueTicketData && isEmpty(issueTicketData?.firstName ?? "")) {
      errors.firstName = "Please enter  First Name";
    }
    if (issueTicketData && isEmpty(issueTicketData?.lastName ?? "")) {
      errors.lastName = "Please enter  Last Name";
    }
    if (issueTicketData && isEmpty(issueTicketData?.email ?? "")) {
      errors.email = "Please enter Address";
    }
    if (
      !isEmpty(issueTicketData?.email) &&
      !isValidEmail(issueTicketData?.email)
    ) {
      errors.email = "Please enter a valid email";
    }
    if (newTableData && !newTableData?.totalTicketPrices) {
      errors.totalTicketPrices = "At least one ticket is required.";
    }
    if (
      issueTicketData &&
      isEmpty(issueTicketData?.phoneNumber?.toString() ?? "")
    ) {
      console.log("");
    } else if (!isValidPhoneNumber(issueTicketData?.phoneNumber?.toString())) {
      errors.phoneNumber = "Invalid Phone Number";
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  return (
    <>
      <Helmet>
        <title> Issue Ticket | EventPrix </title>
      </Helmet>

      <Container maxWidth={"xl"} style={{ marginBottom: marginBottomSize }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Icon
              width="30"
              height="30"
              style={{ marginRight: 5 }}
              icon="fluent-emoji-high-contrast:free-button"
            />
            <Typography variant="h4">Issue Ticket</Typography>
          </div>
        </Stack>

        <Card>
          <Grid
            container
            spacing={4}
            style={{ padding: "30px 30px  0 30px " }}
            alignItems="center"
          >
            <Grid item xs={12} sm={6} md={3}>
              <AutoCompleteDropDown
                data={eventLists}
                onChange={handleOnChange}
                label={"title"}
                dropDownDisplayLabel={"Event Name "}
                placeholder={"Event Name"}
              />
            </Grid>
          </Grid>
          <Grid
            container
            spacing={4}
            style={{ padding: "30px" }}
            alignItems="center"
          >
            <Grid item xs={12} sm={12}>
              <PriceTable
                newData={(newData: any) => handleNewData(newData)}
                values={ticketConfigData}
                error={formErrors.totalTicketPrices}
              />
            </Grid>
            <Grid item xs={12} sm={9}>
              <Card>
                <CardContent>
                  <Grid
                    container
                    spacing={4}
                    style={{ padding: "15px 0 15px 0" }}
                    alignItems="center"
                  >
                    <Grid item xs={12} sm={6}>
                      <TexBoxWithLabel
                        multiline={true}
                        size="small"
                        placeholder="First Name"
                        label="First Name"
                        value={issueTicketData?.firstName}
                        onChange={(firstName) =>
                          onChangeFormData("firstName", firstName)
                        }
                      />
                      <ValidationError formErrors={formErrors.firstName} />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TexBoxWithLabel
                        multiline={true}
                        size="small"
                        placeholder="Last Name"
                        label="Last Name"
                        value={issueTicketData?.lastName}
                        onChange={(lastName) =>
                          onChangeFormData("lastName", lastName)
                        }
                      />
                      <ValidationError formErrors={formErrors.lastName} />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TexBoxWithLabel
                        multiline={true}
                        size="small"
                        placeholder="Email"
                        label="Email"
                        value={issueTicketData?.email}
                        onChange={(email) => onChangeFormData("email", email)}
                      />
                      <ValidationError formErrors={formErrors.email} />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <TextField
                        size="small"
                        placeholder="(000) 000-0000"
                        label="Phone Number"
                        fullWidth
                        variant="outlined"
                        value={issueTicketData?.phoneNumber}
                        onChange={(phoneNumber) =>
                          onChangeFormData("phoneNumber", phoneNumber)
                        }
                        name="PhoneNumber"
                        id="formatted-text-mask-input"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                          inputComponent: TextMaskCustom as any,
                        }}
                      />
                      <ValidationError formErrors={formErrors.phoneNumber} />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={12}>
              <LoadingButton
                style={{
                  backgroundColor: Color.primary,
                  width: "100%",
                  marginTop: "20px",
                }}
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                onClick={handleCheckOut}
              >
                Submit
              </LoadingButton>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={4}
            style={{ padding: "30px" }}
            alignItems="center"
          ></Grid>
        </Card>
      </Container>
      <FullScreenLoader open={loader} />
    </>
  );
}
